import React from 'react';
import { styled } from '@abyss/web/tools/styled';
import { PageBody } from '@abyss/web/ui/PageBody';
import { Button } from '@abyss/web/ui/Button';
import { Box } from '@abyss/web/ui/Box';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { Heading } from '@abyss/web/ui/Heading';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

const MainContainer = styled('div', {
  minHeight: 'calc(100vh)',
  background: '$gray2',
  zIndex: 1200,
});

const StyledPageBody = styled(PageBody, {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1320,
  '@media screen and (max-width: 1380px)': {
    paddingLeft: 40,
    paddingRight: 40,
  },
});

const MarginTop = styled('div', {
  marginTop: 25,
});

const DialogContainer = styled('div', {
  textAlign: 'center',
  marginTop: '50px',
  maxWidth: '80%',
  margin: '0 auto',
});

export const ServiceUnavailable = () => {
  const errorDetails = {
    title: 'Service Unavailable',
    desc: 'We are working on restoring this service as quickly as possible.',
    subtitle: 'Please try again later.',
  };

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <React.Fragment>
      <MainContainer data-testid="initialize-app-error-page">
        <StyledPageBody>
          <MarginTop />
          <DialogContainer>
            <Box color="white">
              <Layout.Stack alignLayout="center" space={16}>
                <IconBrand size="72" icon="alert" />
                <Heading data-testid="initialize-app-error-page-title">
                  {errorDetails.title}
                </Heading>
                <Layout.Stack alignLayout="center" space={0}>
                  <Text data-testid="initialize-app-error-page-desc">
                    {errorDetails.desc}
                  </Text>
                  <Text data-testid="initialize-app-error-page-subtitle">
                    {errorDetails.subtitle}
                  </Text>
                </Layout.Stack>
                <Button data-testid="retry" onClick={handleRetry}>
                  Retry
                </Button>
              </Layout.Stack>
            </Box>
          </DialogContainer>
        </StyledPageBody>
      </MainContainer>
    </React.Fragment>
  );
};
